module.exports = __webpack_public_path__ + "img/confetti_1e.85d481d7.svg";